"use client";
import NotFound from "@/components/base/NotFound";

const index = () => {
  return <NotFound />;
};

export default index;
